/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: NonNullable<unknown> }} No_Intensity_On_ClosureInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "No intensity detection on valve closure" |
* | "true" | "No intensity detection on valve closure since {date}" |
* | * | "No intensity detection on valve closure" |
*
* @param {No_Intensity_On_ClosureInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const no_intensity_on_closure = /** @type {((inputs: No_Intensity_On_ClosureInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Intensity_On_ClosureInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`No intensity detection on valve closure`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`No intensity detection on valve closure since ${i?.date}`);
		return /** @type {LocalizedString} */ (`No intensity detection on valve closure`)
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Pas de détection d'intensité en fermeture de vanne`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Pas de détection d'intensité en fermeture de vanne depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ (`Pas de détection d'intensité en fermeture de vanne`)
	}
});